let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7lJbN")).then(() => parcelRequire('8aLn9'));